import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-layer-close-icon",
  "use": "icon-map-layer-close-icon-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon-map-layer-close-icon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.46 14.714a.833.833 0 1 0 1.178 1.178l4.713-4.713 4.714 4.714a.833.833 0 0 0 1.179-1.179L11.53 10l4.714-4.714a.833.833 0 0 0-1.178-1.179L10.35 8.822 5.637 4.107A.833.833 0 1 0 4.46 5.286L9.173 10l-4.714 4.714Z\" fill=\"#4C556C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol